window.onload = function() {
  (function($){

    document.querySelector("body").classList.add("loaded-doc");
    
    if(document.querySelector(".m-h .nav-trigger")){
      document.querySelector(".m-h .nav-trigger").addEventListener("click", function(e){ 
        document.querySelector("body").classList.toggle("mobile-nav-active");
        e.preventDefault(); 
      });
    }
    if($(".template-product .info-table").length > 0) {
      $(".template-product .info-table tr").each(function(){
        if($(this).attr("style")) {
          $(this).addClass("keep-me-hidden").remove();
        }
      })
    }
    $(document).on("click", ".mobile-menu .mm-close", function() {
      $("body").toggleClass("mobile-nav-active");
      return false;
    });
    $(document).on("click", ".ar-block", function(){
    if($(this).attr("data-url")){
      window.location = $(this).attr("data-url");
    }
    }); 
    if($("#pbundleid").length > 0) {
      $(".form-action .action-buttons #AddToCart").remove(); 
      $(".form-action .action-buttons").append('<button id="CAddToCart">Add To Cart</button>'); 
      $("#AddToCartForm").append('<div class="hidden-functionality" role="none" aria-hidden="true"><input id="bundleid" type="text" name="properties[bundleid]" value="'+$("#pbundleid").attr("data-bid")+'"  readonly></div>'); 
    }
    function addToCartOk(product) {
      window.location.href = "/cart";
    }
    if($(".product-listing.hpf .gr-entry .image-card").attr("data-himage")){
      $(".product-listing.hpf .gr-entry .image-card").hover(
        function () {
          let himage = $(this).attr("data-himage");
          if(himage.length > 0 ) {
            $(this).css("background-image", "url("+himage+")");
          }
        },
        function () {
          let himage = $(this).attr("data-himage");
          if(himage.length > 0 ) {
            let nimage = $(this).attr("data-nimage");
            $(this).css("background-image", "url("+nimage+")");
          }
        }
      );
    }

    function addToCartFail(obj, status) { 
      alert("There was an error."); 
    } 
    
    if($("#sCartForm").length > 0) {
      var defcart = [];
      $("#sCartForm .item-with-bundle").each(function(){
        defcart.push({
          id: $(this).attr("data-pid"),
          quantity: $(this).attr("data-pq")
        });
      });
      defcart.push({
        id: $("#sCartForm .item-bundle").attr("data-bid"),
        quantity: $("#sCartForm .item-bundle").attr("data-bq")
      });
      function getDCart(id){
        for(var x in defcart){
          if(defcart[x].id && defcart[x].id.indexOf(id.toString())!=-1) return defcart[x].quantity;
        }
        return "Not Found";
      }
     //console.log(defcart);
    }

    $(document).on("click", "#cartUpdate", function(){
      var cpq = 0;
      var cqv = 0;
      var bq = 0;
      $("#sCartForm .cart-item").each(function(){
        var cpid = $(this).attr("data-pid");
        var cpq = Number($(this).attr("data-pq"));
        var cqv = Number($(".ci-quant .ci-quant-value",this).val());
        if(cqv !== cpq && $(this).hasClass("item-with-bundle")) {
          console.log("found item that needs to be updated: "+cpid);
          var bid = Number($("#sCartForm .item-bundle").attr("data-bid"));
          var bq = Number($("#sCartForm .item-bundle").attr("data-bq"));
          console.log(bid+" bundle quant: "+bq);
          var nq = 0;
          if(cqv == 0) { 
            var nq = bq - cpq;
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: {
                  [cpid]: 0,
                  [bid]: nq
                }
              },
              dataType: 'json',
              success: function(cart){ 
                //console.log(cart);
                window.location.reload() 
              },
              error: function(err){ console.error('Error!', err) }
            });
          }
          else if(cqv < cpq) {
			var nq = bq - (cpq - cqv);
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: {
                  [cpid]: cqv,
                  [bid]: nq
                }
              },
              dataType: 'json',
              success: function(cart){ 
                //console.log(cart);
                window.location.reload() 
              },
              error: function(err){ console.error('Error!', err) }
            });
          }
          else { 
            var nq = bq + (cqv - cpq);
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: {
                  [cpid]: cqv,
                  [bid]: nq
                }
              },
              dataType: 'json',
              success: function(cart){ 
                //console.log(cart);
                window.location.reload() 
              },
              error: function(err){ console.error('Error!', err) }
            });
          }
          $("#sCartForm").submit(function(e){
            e.preventDefault();
          });
          return false;
        }
      });

    });
    
    
    $(document).on("click", ".remove-product a", function(){
      if($(this).parent().parent().find(".has-bundle-id").length > 0){
        let bid = $(this).parent().parent().find(".has-bundle-id").attr("data-bid");
        let cpid = $(this).parent().parent().find(".has-bundle-id").attr("data-cpid");
        var addq = Number(getDCart(bid)) - $(this).attr("data-cpq");


          
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          dataType: "json",
          data: { 
            updates:{
              [parseFloat(bid)]: addq,
              [parseFloat(cpid)]: 0
            } 
          },
        }).then((data) => {
          window.location.reload();
        });


        return false;
      }
    });
    $(document).on("click", "#CAddToCart", function(){
      let mcpa = [];
      var bundleID = $("#pbundleid").attr("data-bid");
      var cps = $("#AddToCartForm").serialize(),
          cps = cps.substring(0, cps.indexOf("&")),
          cps = cps.substr(cps.indexOf("=") + 1);
      var cpq = Number($("#AddToCartForm #Quantity").val());
      mcpa.push({
        "id": bundleID,
        "quantity": cpq,
      });
      if($("#bundleid").val()) {
        mcpa.push({
          "id": cps,
          "quantity": cpq,
          "properties": {
            'bundleId': $("#bundleid").val()
          },
        });
      }
      else {
        mcpa.push({
          "id": cps,
          "quantity": cpq,
        });
      }

      $("#AddToCartForm").submit(function(e){
        e.preventDefault();
      });


      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: mcpa },
        dataType: 'json',
        success: addToCartOk,
        error: addToCartFail
      });

      return false;
    });


    if($(".hp-fp-row .col-4.product-listing.hpf").length > 0) {
      $(".col-4.product-listing.hpf .gr-entry:first").addClass("active");
    }
    $('a[target="_blank"]').each(function(){
      $(this).attr("title","Link will open in a new tab");
    });
    $(document).on("click",".mfpc",function(){
      if($(this).hasClass("prev")){
        if($(".col-4.product-listing.hpf .gr-entry.active").prev().hasClass("gr-entry")) {
          $(".col-4.product-listing.hpf .gr-entry.active").removeClass("active").prev().addClass("active");
        }
        else {
          $(".col-4.product-listing.hpf .gr-entry").removeClass("active");
          $(".col-4.product-listing.hpf .gr-entry:last").addClass("active");
        }
      }
      if($(this).hasClass("next")){
        if($(".col-4.product-listing.hpf .gr-entry.active").next().hasClass("gr-entry")) {
          $(".col-4.product-listing.hpf .gr-entry.active").removeClass("active").next().addClass("active");
        }
        else {
          $(".col-4.product-listing.hpf .gr-entry").removeClass("active");
          $(".col-4.product-listing.hpf .gr-entry:first").addClass("active");
        }
      }
      return false;
    });
    $(document).on("click",".images-row a",function(){
      let cimg = $(this).attr("data-image");
      $(".product-featured-image").css("background-image","url("+cimg+")");
      $(".images-row a").removeClass("current");
      $(this).addClass("current");
      return false;
    });
    if($(".page-cols .sidebar-nav").length > 0) {
      var curl = window.location.href; 
      $(".page-cols .sidebar-nav .smi-copy a").each(function(){
        let cat = $(this).attr("href");
        if(curl.includes(cat)) {
          $(this).addClass("current-item");
        }
      });
    }

    $(document).on("click",".recover-pass",function(){
      var tlbl = $(this).text();
      var h1txt = $("h1").text();
      $(this).text(tlbl == "Forgot your password?" ? "Login" : "Forgot your password?");
      $("h1").text(h1txt == "Login" ? "Recover password" : "Login");
      $(".login-user-form, .recover-pass-form").toggleClass("hidden");
      return false;
    });
    $(document).on("click",".sidebar-nav .mobile-trigger",function(){
      $(".sidebar-nav").toggleClass("visible");
      return false;
    });
    $(document).on("click",".sidebar-nav .smi-heading.no-link",function(){
      if($(this).parent().hasClass("open-nav")) {
        $(this).parent().toggleClass("active");
      }
      else {
        $(".sidebar-nav .sm-item").not($(this).parent()).removeClass("active");
        $(this).parent().toggleClass("active");
      }
      return false;
    });
    $(document).on("click",".search-trigger, .msm-close",function(){
      $(".mobile-search-modal").toggleClass("active");
      return false;
    });
    $(document).on("click","#main-menu .menu-item.is-parent a",function(){
      if($(this).parent().hasClass("is-parent")) {
        $("#main-menu li.is-parent").not($(this).parent()).removeClass("open");
        $("#main-menu li.is-parent a").not($(this)).attr("aria-expanded", "false");
        $(this).parent().toggleClass("open");
        $(this).attr('aria-expanded', function(_, attr){ return !attr});
        return false;
      }
    });
    $("#main-menu .menu-item").hover(function() {
      $("#main-menu li").removeClass("open");
    });

    $("#main-menu .main-navigation .child").each(function(){
      if($(".grandchild",this).length > 0) {
        $(this).addClass("has-grandchilds");
        $(this).parent().addClass("grandfather");
      }
    });

    function formatMoney(number, decPlaces, decSep, thouSep) {
      decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
      decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return sign +
          (j ? i.substr(0, j) + thouSep : "") +
          i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
          (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
    }

    window.qv = 1;
    function updateSelectedVariant() {
      var wts = "";
      var cvp = 0;
      var cvop = 0;
      var saving = 0;
      $(".product-options-selector .so-selector").each(function(){
        let csval = $(":selected", this).val();
        wts = wts + csval;
      });
      $(".vidselector li").each(function(){
        let vidsellabel = $("span", this).text();
        if(vidsellabel == wts) {
          let fv = $(this).attr("data-vid");
          if($(this).attr("data-price").includes(",")) {
            var cvp = Number($(this).attr("data-price").replace(/[^0-9\.]+/g, ""));
          }
          else {
            var cvp = Number($(this).attr("data-price"));
          }
          if($(this).attr("data-oprice")) {
            //stian
            if($(this).attr("data-oprice").includes(",")) {
              var cvop = Number($(this).attr("data-oprice").replace(/[^0-9\.]+/g, ""));
            }
            else {
              var cvop = Number($(this).attr("data-oprice"));
            }
          }
          $("#AddToCartForm .form-action").removeClass("hidden-functionality");
          if(cvop && cvop > cvp) {
            var saving = cvop - cvp;
            var percent = ((cvop - cvp) * 100)/cvop;
            $(".price-range").html("$"+cvp.toFixed(0)+" <span>$"+cvop.toFixed(0)+"</span> <span>(You save $"+saving.toFixed(0)+" - "+percent.toFixed(0)+"%)</span>");
            if($(".product-featured-image .promo").length > 0 && percent.toFixed(0) > 0) {
              $(".product-featured-image .promo").text(+percent.toFixed(0)+"% Off");
            }
            // {{ product.selected_or_first_available_variant.compare_at_price | minus: product.selected_or_first_available_variant.price | times: 100.0 | divided_by: product.selected_or_first_available_variant.compare_at_price | ceil
            //$(".price-range").html(cvp.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')+" <span>"+cvop.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')+"</span> <span>(You save $"+saving.toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')+")</span>");
          }
          else {
            if(cvp == 0) {
              $(".price-range").html("This product is currently unavailable");
              $("#AddToCartForm .form-action").addClass("hidden-functionality");
            }
            else {
              $(".price-range").html("$"+cvp.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
            }
          }
          $("#productSelect").prop('selectedIndex',0);
          
          if($("#productSelect option[value="+fv+"]").length > 0) {
            $(".oos-notice").addClass("hidden-functionality");
            $(".price-range, .form-action").removeClass("hidden-functionality");
            $("#productSelect option[value="+fv+"]").prop('selected', true);
          }
          else {
            $(".oos-notice").removeClass("hidden-functionality");
            $(".price-range, .form-action").addClass("hidden-functionality");
          }
          if($("#productSelect option:selected").attr("data-img")){
            $(".product-featured-image").css("background-image","url("+$("#productSelect option:selected").attr("data-img")+")");
          }
        }
      });
    }
    /*
    if($("#productSelect").length > 0) {
      console.log("product with multiple options");
      $("#productSelect :disabled").each(function(){
        let won = $(this).attr("data-vname").replace(' ', '');
        let sizeName = won.substr(0, won.indexOf('/'));
        let optionName = won.substring(won.lastIndexOf('/ ')+1)
        console.log(sizeName);
        console.log(optionName);
      });
      //stian
    }
    */
    if($("#productSelect").length > 0) {
      if($("#productSelect option:first").text().includes("sold out")){
        $("#AddToCartForm .form-action").addClass("hidden-functionality");
      }
    }
    
    $(document).on('change', '.product-options-selector select', updateSelectedVariant);
    $(document).on("click",".pa-block .variant-selector a",function(){
      $(this).parent().find("a").removeClass("selected");
      $(this).addClass("selected");
      let soption = $(this).attr("data-option");
      let selectorID = $(this).parent().attr("data-selector");
      $("#"+selectorID+" option[value='"+soption+"']").prop("selected", true); 
      updateSelectedVariant();
      return false;
    });
    window.qv = 1;
    $(document).on("click",".quant-selector a",function(){
      if($("#Quantity").length > 0) {
        var qi = $("#Quantity");
      }
      if($(this).hasClass("minus")) {
        if(!$(this).hasClass("inactive")){
          let fqf = Number($(this).parent().find(".total-quant").text()) - 2;
          let fq = Number($(this).parent().find(".total-quant").text()) - 1;
          $(this).parent().find(".total-quant").empty();
	      $(this).parent().find(".total-quant").text(fq);
          qi.val(fq);
          if(fqf < 1) {
            $(this).addClass("inactive");
          }
        }
      }
      if($(this).hasClass("plus")) {
        if($(".quant-selector a.minus").hasClass("inactive") && Number($(this).parent().find("span").text()) > 1) {
          $(".quant-selector a.minus").removeClass("inactive");
        }
		let fq = Number($(this).parent().find(".total-quant").text()) + 1;
        $(this).parent().find(".total-quant").empty();
        $(this).parent().find(".total-quant").text(fq);
        qi.val(fq);
      }
      return false;
    });
    if(window.location.href.indexOf("?showinfo") > -1) {
      if($(".product-variants-list").length > 0) {
      $(".product-variants-list").removeClass("hidden-functionality");
      }
    }
    else if(window.location.href.indexOf("?variant") > -1) {
      if($(".not-default-variant").length > 0) {
        let cvariant = $(".not-default-variant").attr("data-vname");
        let vrntfields = cvariant.split(' / ');
        let foption = vrntfields[0];
        let soption = vrntfields[1];
        $(".product-options-selector .variant-selector").each(function(){
          $("a",this).each(function(){
            let cov = $(this).attr("data-option");
            if(cov == foption || cov == soption) {
              $(this).click();
            }
          });
        });
      }
    }

    if(window.location.href.indexOf("?sitewithbg") > -1) {
      $("body").addClass("site-with-bg");
    }

    if(window.location.href.indexOf("?newfont") > -1) {
      $(".page-cols.ssn .copy-block, .shopify-section.icons-w-label, .shopify-section.testimonials-carousel, .shopify-section.faqs, .shopify-section.featured-video").addClass("lucara-text");
    }

    $(document).on("click", ".accordion h3", function(e){
      $(this).parent().toggleClass("active");
      return false;
    });
    $(document).on("click", ".open-modal", function(){
      let vid = $(this).attr("data-vid");
        if(vid) {
          $("body").append('<div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedBy="modalDescription"><div class="modal-overlay modal-hide" tabindex="-1"></div><div class="modal-container modal-hide"> <div id="modalDescription" class="modal-hidden">Beginning of video dialog window.</div> <button class="modal-close modal-hide"><i class="fa fa-times-circle-o"></i> <span style="display: none" aria-hidden="false">Close dialog window</span></button> <h2 id="modalTitle" class="modal-hidden">YouTube Video Dialow Window</h2> <div class="modal-content"> <iframe width="560" height="315" src="https://www.youtube.com/embed/'+vid+'?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div> </div></div>');
          $("main").attr("aria-hidden","true");
          $("main").attr("tabindex","-1");
          $("main, .accs-menu").css("user-select","none");
          $(".modal .modal-close").focus();
          return false;
        }
    });
    $(document).on("click", ".modal .modal-close", function(){
      $(".modal").remove();
      $("main").removeAttr("aria-hidden");
      $("main").removeAttr("tabindex");
      $("main, .accs-menu").removeAttr("style");
      return false;
    });

    document.onkeydown = function(evt) {
        evt = evt || window.event;
        
        var isEscape = false;
      // 39 right arrow
      // 37 left arrow
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
          if($("#main-menu .menu-item.is-parent").hasClass("open")) {
            $("#main-menu .menu-item.is-parent.open").next().focus();
            $("#main-menu .menu-item.is-parent.open a").attr("aria-expanded", "false");
            $("#main-menu .menu-item.is-parent.open").removeClass("open");
          }
          if($(".modal").length > 0) {
            $(".modal").remove();
            $("main").removeAttr("aria-hidden");
            $("main").removeAttr("tabindex");
            $("main, .accs-menu").removeAttr("style");
          }
        }
        if(evt.keyCode == 39 && $("#main-menu .menu-item a").not($("#main-menu .menu-item ul a")).is(":focus")) {
          if($("#main-menu .menu-item a").not($("#main-menu .menu-item ul a")).is(":focus").next().is("li")) {
            $("#main-menu .menu-item a").not($("#main-menu .menu-item ul a")).is(":focus").blur().next().focus();
          }
        }
    };

    if($("#bmq").length > 0) {
      let mn1 = Math.floor(Math.random() * 10);
      let mn2 = Math.floor(Math.random() * 10);
      let res = mn1 + mn2;
      $("#bmq").attr("placeholder",mn1+" + "+mn2);
      $("#bmqa").keyup(function(){
        let ua = Number($("#bmqa").val());
        if(ua == res) {
          $(".cf-submit").removeClass("disabled");
        }
        else {
          $(".cf-submit").addClass("disabled");
        }
      });
    }

    $(document).on("click", ".accordion h3 a", function(){
      $(this).parent().parent().toggleClass("active");
      return false;
    });

    if($(".pr-slider").length > 0) {
      $(".pr-slider").slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }

    if($(".testimonials-carousel").length > 0) {
      $(".testimonials-carousel .tc-content").slick({
        slidesToShow: 3,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 12000,
        infinite: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }



     
  })($);
}
